<template>
  <div class="cta-buttons" :class="{ inline: shoppableRedesignOptimization }">
    <StatefulBButton
      ref="utb"
      variant="emphasis"
      expanded
      :disabled="disabled || isAnyLoading"
      :is-loading="isLoading"
      :aria-label="isLoading ? 'Updating your bag...' : 'Update Bag'"
      @click="promptWnmBeforeAtb(onUTB)"
    >
      Update Bag
    </StatefulBButton>
    <StatefulBButton
      ref="atb"
      variant="secondary"
      expanded
      :disabled="disabled || isAnyLoading"
      :is-loading="isLoading"
      :aria-label="isLoading ? 'Adding another to your bag...' : 'Add another to bag'"
      @click="promptWnmBeforeAtb(onATB)"
    >
      Add another to bag
    </StatefulBButton>
    <component :is="data?.component" v-if="data?.component" @atb-closed="onClose" />
  </div>
</template>

<script setup>
import { ref, watchEffect, nextTick } from 'vue';
import StatefulBButton from '~/modules/ui/components/StatefulBButton';
import useFeatureEligibility from '~/modules/featureControl/composables/useFeatureEligibility';
import { useQuantity } from '~/modules/product/composables/useQuantity';
import useWnmAtbGate from '~/modules/worry-no-more/composables/useWnmAtbGate';
import { useAddToBag } from '../composables/useAddToBag';

const props = defineProps({
  payload: {
    /**
     * @type {import('vue').PropType<import('../types').ATBPayload>}
     */
    type: Object,
    required: true,
  },
  payloadValidator: {
    /**
     * ? That's not the best option to pass function as prop.
     * ? It's trade off between reausablity and Vue conceptions
     * @type {import('vue').PropType<import('../types').ATBPayloadValidator>}
     */
    type: Function,
    required: false,
    default: () => null,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
});

const emits = defineEmits(['error']);

const { shoppableRedesignOptimization } = useFeatureEligibility();
const { isLoading, isAnyLoading, mutate, data, error } = useAddToBag({
  payload: () => props.payload,
  payloadValidator: props.payloadValidator,
});

const { promptWnmBeforeAtb } = useWnmAtbGate();
const { quantity } = useQuantity();

/**
 * @type {import('vue').Ref<InstanceType<typeof StatefulBButton> | null>}
 */
const atb = ref(null);
/**
 * @type {import('vue').Ref<InstanceType<typeof StatefulBButton> | null>}
 */
const utb = ref(null);

/**
 * @type {import('vue').Ref<InstanceType<typeof StatefulBButton> | null>}
 */
const lastClicked = ref(null);

const onATB = async () => {
  lastClicked.value = atb.value;
  try {
    await mutate({ isAddAnotherToBag: true });
    quantity.value += 1;
  } catch {
    // @error
  }
};

const onUTB = () => {
  lastClicked.value = utb.value;
  mutate({ isUpdate: true });
};

const onClose = () => {
  if (data.value?.component) {
    data.value.component = null;
    nextTick(() => {
      lastClicked.value?.$el.focus();
      lastClicked.value = null;
    });
  }
};

watchEffect(() => {
  emits('error', error.value);
});
</script>
